import React, { useState } from "react";
import styles from "./auth.module.css";
import { useFormik } from "formik";
import * as yup from "yup";
import InputCustom from "./InputCustom";
import axios from "axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";

const Register = () => {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const initialValues = {
    name: "",
    email: "",
    phone: "",
  };
  const onSubmit = (state) => {
    setLoader(true);
    const registerData = {
      name: state.name,
      email: state.email,
      phone: state.phone,
      code: "",
      type_App: "panel",
    };
    axios
      .post("https://arianaapp.arianaapply.com/panel/register", registerData)
      .then((res) => {
        setLoader(false);
        console.log(res);
        Swal.fire({
          title:
            "ثبت نام شما با موفقیت انجام شد پس از بررسی و تایید ادمین شما میتوانید وارد شوید",
          icon: "success",
        }).then(() => {
          history.push("/login");
        });
      })
      .catch((err) => {
        setLoader(false);
        if (err.response.status === 422) {
          Swal.fire({
            title: "شما قبلا ثبت نام کرده اید",
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "مشکلی پیش امده دوباره امتحان کنید",
            icon: "error",
          });
        }
      });
  };
  const phoneRegex = new RegExp("^{?(0?9[0-9]{9,9}}?)$");
  const validationSchema = yup.object({
    name: yup.string().required("نام خود را وارد کنید"),
    email: yup
      .string()
      .email("ایمیل نامعتبر است")
      .required("وارد کردن ایمیل الزامیست"),
    phone: yup
      .string()
      .required("وارد کردن شماره تماس الزامیست")
      .matches(phoneRegex, "شماره تماس نامعتبر است")
      .nullable(),
  });
  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <div className={styles.authPage}>
      <form className={styles.authForm} onSubmit={formik.handleSubmit}>
        <h4 className={styles.authTitle}>
          ثبت نام در پنل اپلیکیشن آریانا پارس
        </h4>
        <InputCustom
          name="name"
          type="text"
          label="نام و نام خانوادگی:"
          formikHandler={formik.getFieldProps("name")}
          formikErrors={formik.errors.name && formik.touched.name}
          formikErrorsName={formik.errors.name}
        />
        <InputCustom
          name="email"
          type="text"
          label="ایمیل:"
          formikHandler={formik.getFieldProps("email")}
          formikErrors={formik.errors.email && formik.touched.email}
          formikErrorsName={formik.errors.email}
        />
        <InputCustom
          name="phone"
          type="text"
          label="شماره تماس:"
          formikHandler={formik.getFieldProps("phone")}
          formikErrors={formik.errors.phone && formik.touched.phone}
          formikErrorsName={formik.errors.phone}
        />

        <button
          className={styles.submitButton}
          type="submit"
          disabled={!formik.isValid}
        >
          {loader ? (
            <Spinner animation="border" variant="light" />
          ) : (
            "ثبت نام"
          )}
        </button>
        <span className={styles.authPush} onClick={()=> history.push('/login')}>قبلا ثبت نام کرده اید؟</span>
      </form>
    </div>
  );
};

export default Register;
